import axios, { AxiosResponse } from "axios";
import { getCredentialHeaders } from "./credentialHeaders";
import { useAccountStore } from "@/stores/accountStore";

const buildAuthHeaders = (): Record<string, string> => {
    const { seller: sellerId } = useAccountStore.getState();
    const headers: Record<string, string> = { "X-APP": "X2 Seller", ...getCredentialHeaders() };
    if (sellerId) headers["X-SELLER-ID"] = sellerId;
    return headers;
};

/**
 * Fetches a binary resource with Xola authentication headers. Returns the whole
 * response so callers can read a server-sent filename out of the headers.
 * Use this instead of importing axios directly for authenticated blob downloads.
 */
export const fetchBlob = async (url: string): Promise<AxiosResponse<Blob>> => {
    return axios.get<Blob>(url, {
        responseType: "blob",
        timeout: 15_000,
        headers: buildAuthHeaders(),
    });
};

/**
 * The upload endpoints read the file name from `qqfile`, so it has to ride in the query string
 * whether or not the URL already carries one.
 */
export const withUploadFileName = (url: string, fileName: string) => {
    const separator = url.includes("?") ? "&" : "?";

    return `${url}${separator}qqfile=${encodeURIComponent(fileName)}`;
};

/**
 * Uploads a File via POST. Bypasses the api client to avoid the stringifyDates interceptor
 * corrupting binary payloads. Use this instead of importing axios directly for file uploads.
 */
export const uploadFile = async (
    url: string,
    file: File,
    headers?: Record<string, string>,
): Promise<AxiosResponse<any>> => {
    return axios.post(withUploadFileName(url, file.name), file, {
        headers: { ...getCredentialHeaders(), ...headers },
    });
};
